import type { JobItemResultVisibleJob } from '../../helpers';

export type JobResultOrAd = JobItemResultVisibleJob | 'Ad';

const AD_INDEX = 5;

export const injectItemsIntoJobList = (
  jobs: JobItemResultVisibleJob[]
): JobResultOrAd[] => {
  const urgentIndex = jobs.findIndex(
    (job) => job.jobDetail?.serviceOfferingGroup > 0
  );
  const updatedJobs = urgentIndex > 0 ? [jobs[urgentIndex], ...jobs] : jobs;

  const firstPart = updatedJobs.slice(0, AD_INDEX);
  const lastPart = updatedJobs.slice(AD_INDEX);
  const ad = ['Ad' as const];

  return [...firstPart, ...ad, ...lastPart];
};
